/**
 * Centralized AI tool name definitions
 * This is the single source of truth for AI tool names and their display labels
 */
export const TOOL_DISPLAY_NAMES = {
  // Fortune
  'fortune_get_executive_pnl': 'Fortune',
  'fortune_get_executive_pnl_v1': 'Fortune',
  'fortuneTools___fortune_get_executive_pnl_v1': 'Fortune',
  // FRI
  'fri_get_profit_and_loss': 'FRI',
  'fri_get_profit_and_loss_v1': 'FRI',
  'FRI-AgentCore-Gateway-Prod___fri_get_profit_and_loss_v1': 'FRI',
  'FRI-AgentCore-Gateway___fri_get_profit_and_loss_v1': 'FRI',
  // SliceIt
  'get_business_trends': 'SliceIt',
  'get_business_trends_v1': 'SliceIt',
  'get-buisness-trends-lambda___get_business_trends_v1': 'SliceIt',
  // FinSpace
  'finspace_post_process_financial_data': 'P&L Formatter',
  'finspace-mcp-tools___finspace_post_process_financial_data': 'P&L Formatter',
  'mfr-generate-commentary': 'FinSpace Commentary Tool',
  'netppm-generate-commentary': 'FinSpace Commentary Tool'
} as const;

/**
 * URL mappings for AI tools
 * Maps display names to their external URLs
 */
export const TOOL_URLS: Record<string, string> = {
  'FRI': 'https://fri.finergy.amazon.dev/wwasf_decks/',
  'Fortune': 'https://reporting.allocations.finergy.amazon.dev/',
  'SliceIt': 'https://sliceit.corp.amazon.com/'
};

/**
 * Get the user-friendly display label for an AI tool name
 * @param toolName - The internal tool name (e.g., 'fri_get_profit_and_loss_v1')
 * @returns The display label (e.g., 'FRI'), or the original tool name if no mapping exists
 */
export const getToolDisplayName = (toolName: string): string => {
  return TOOL_DISPLAY_NAMES[toolName as keyof typeof TOOL_DISPLAY_NAMES] || toolName;
};

/**
 * Get the URL for an AI tool based on its display name
 * @param displayName - The display name of the tool (e.g., 'FRI', 'Fortune')
 * @returns The URL if available, undefined otherwise
 */
export const getToolUrl = (displayName: string): string | undefined => {
  return TOOL_URLS[displayName];
};
